<template>
  <div class="tab-banner" :class="[zsTjTheme]">
    <div class="title-line">
      <div class="title">
        <div class="text">{{ $t("tj.zs.jsmt") }}</div>
      </div>
      <div v-if="calcSortData && calcSortData.length" class="round-container" data-map-key="tabSortData">
        <div
          v-for="(item, index) in calcSortData"
          :key="item"
          :class="['round-item', index === currentTab ? 'active' : '']"
          @click="handleClick(index)"
        >
          {{ tabLangMap[item] }}
        </div>
      </div>
    </div>

    <div class="content" :data-map-key="`bannerImg_${imgKey}`">
      <template v-if="currentShowData[`bannerImg_${imgKey}_limit`] && isUserLimit">
        <img :src="currentShowData[`bannerImg_${imgKey}_limit`]" alt="" />
      </template>
      <template v-else>
        <img v-if="currentShowData[`bannerImg_${imgKey}`]" :src="currentShowData[`bannerImg_${imgKey}`]" alt="" />
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    currentShowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabSortData: ["宣传图", "角色档案", "生日贺图", "二创图"],
      tabLangMap: {
        宣传图: this.$t("tj.zs.xct"),
        角色档案: this.$t("tj.zs.jsda"),
        生日贺图: this.$t("tj.zs.srht"),
        二创图: this.$t("tj.zs.ect")
      },
      currentTab: 0
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    isUserLimit() {
      return !this.loginUid || !this.loginUser || (!this.loginUser.adulthood && !this.loginUser.is_super);
    },
    imgKey() {
      return this.calcSortData[this.currentTab];
    },
    calcSortData() {
      if (this.isEdit) {
        if (this.currentShowData.tabSortData && this.currentShowData.tabSortData.length) {
          return this.currentShowData.tabSortData;
        }
        return this.tabSortData;
      }
      const sortData = this.currentShowData.tabSortData || [];
      // 将tabsortdata按sortdata顺序排序
      const tabSortData = this.tabSortData;
      const result = tabSortData.sort((a, b) => {
        const indexA = sortData.indexOf(a);
        const indexB = sortData.indexOf(b);
        return indexA - indexB;
      });
      return result.filter(item => this.currentShowData[`bannerImg_${item}`]);
    }
  },
  methods: {
    handleClick(index) {
      this.currentTab = index;
    }
  }
};
</script>
<style lang="less" scoped>
.tab-banner {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  margin-bottom: 50px;
  overflow: hidden;
  .title-line {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .title {
      position: relative;
      width: 229px;
      height: 36px;
      margin-bottom: 5px;
      padding-left: 35px;
      box-sizing: border-box;
      line-height: 36px;
      background: url("~@/assets/zs_imgs/advice-title-bg.png") no-repeat;
      background-size: 100% 100%;
      .text {
        z-index: 1;
        font-weight: bold;
        font-size: 19px;
        color: #ffffff;
      }
      &::before {
        z-index: 1;
        content: "";
        position: absolute;
        top: 3px;
        left: 3px;
        width: 28px;
        height: 28px;
        background: url("~@/assets/zs_imgs/pic-title-icon.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .round-container {
      display: flex;
      align-items: center;
      user-select: none;
      height: 36px;
      padding: 4px 4px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      box-sizing: border-box;

      .round-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0 20px;
        border-radius: 4px;
        color: #ccc;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s;
        &.active {
          color: #fff;
          background: #3b4655;
          color: #fff;
        }
      }
    }
  }

  .content {
    text-align: center;
    flex: 1;
    padding: 20px 14px;
    background: rgba(10, 10, 10, 0.6);
    border-radius: 16px;
    overflow: hidden;
    img {
      max-height: 100%;
      max-width: 100%;
      object-fit: cover;
    }
  }
}
.tab-banner.light {
  .title-line {
    .title {
      .text {
        color: #333333;
      }
      &::before {
        background: url("~@/assets/zs_imgs/light-advice-title-bg.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .round-container {
      background: rgba(255, 255, 255, 0.6);
      .round-item {
        color: rgba(51, 51, 51, 0.7);
        &.active {
          color: #fff;
          background: #474c4f;
        }
      }
    }
  }
  .content {
    background: rgba(133, 168, 181, 0.3);
  }
}
</style>
